// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3J28Q","insightsList":"newBusinessInsightsMenu_insightsList__3q5TX","active":"newBusinessInsightsMenu_active__1Hmzt"};